// employeeService.js
// API service functions for Employee Management (Departments, Employee Types, Employees, Payroll)

import API from './api';

// ============================================================================
// Departments
// ============================================================================

export const getDepartments = async () => {
  const response = await API.get('/departments/');
  return response.data;
};

export const createDepartment = async (data) => {
  const response = await API.post('/department/create/', data);
  return response.data;
};

export const updateDepartment = async (data) => {
  const response = await API.put('/department/update/', data);
  return response.data;
};

export const deleteDepartment = async (departmentId) => {
  const response = await API.delete('/department/delete/', {
    data: { DepartmentID: departmentId }
  });
  return response.data;
};

// ============================================================================
// Employee Types
// ============================================================================

export const getEmployeeTypes = async () => {
  const response = await API.get('/employee-types/');
  return response.data;
};

export const createEmployeeType = async (data) => {
  const response = await API.post('/employee-type/create/', data);
  return response.data;
};

export const updateEmployeeType = async (data) => {
  const response = await API.put('/employee-type/update/', data);
  return response.data;
};

export const deleteEmployeeType = async (typeId) => {
  const response = await API.delete('/employee-type/delete/', {
    data: { TypeID: typeId }
  });
  return response.data;
};

// ============================================================================
// Employees
// ============================================================================

export const getEmployees = async (params = {}) => {
  const response = await API.get('/employees/', { params });
  return response.data;
};

export const getEmployee = async (employeeId) => {
  const response = await API.get('/employee/', {
    params: { employee_id: employeeId }
  });
  return response.data;
};

export const createEmployee = async (data) => {
  const response = await API.post('/employee/create/', data);
  return response.data;
};

export const updateEmployee = async (data) => {
  const response = await API.put('/employee/update/', data);
  return response.data;
};

export const deleteEmployee = async (employeeId) => {
  const response = await API.delete('/employee/delete/', {
    data: { EmployeeID: employeeId }
  });
  return response.data;
};

// ============================================================================
// Payroll Submissions
// ============================================================================

export const getPayrollSubmissions = async (params = {}) => {
  const response = await API.get('/payroll-submissions/', { params });
  return response.data;
};

export const getEmployeePayrollHistory = async (employeeId) => {
  const response = await API.get('/payroll-submissions/', {
    params: { employee_id: employeeId }
  });
  return response.data;
};

export const getPayrollSubmission = async (submissionId) => {
  const response = await API.get('/payroll-submission/', {
    params: { submission_id: submissionId }
  });
  return response.data;
};

export const createPayrollSubmission = async (data) => {
  const response = await API.post('/payroll-submission/create/', data);
  return response.data;
};

export const createBulkPayrollSubmissions = async (data) => {
  const response = await API.post('/payroll-submission/bulk-create/', data);
  return response.data;
};

export const updatePayrollSubmission = async (data) => {
  const response = await API.put('/payroll-submission/update/', data);
  return response.data;
};

export const deletePayrollSubmission = async (submissionId) => {
  const response = await API.delete('/payroll-submission/delete/', {
    data: { SubmissionID: submissionId }
  });
  return response.data;
};

export const bulkUpdatePayrollStatus = async (data) => {
  // data = { SubmissionIDs: [...], PaymentStatus: 'paid'|'waiting', PaymentDate: 'YYYY-MM-DD' }
  const response = await API.post('/payroll-submission/bulk-status/', data);
  return response.data;
};

// ============================================================================
// Metrics
// ============================================================================

export const getEmployeeMetrics = async (params = {}) => {
  const response = await API.get('/employee-metrics/', { params });
  return response.data;
};
